<template>
  <mock-up-main>
    <component
      :is="components[value.photo?.transition || 'scale']"
      mode="out-in"
      origin="center"
    >

      <div
        v-if="showWelcome && value?.photo?.hasWelcome"
        class="col-md-11 bg-white mx-auto d-flex"
        style="min-height: 75vh"
        key="loading"
      >
        <div class="col m-auto" v-if="value?.photo?.welcome === ''">
          <atom-spinner :animation-duration="1000" :size="80" class="mx-auto justify-content-center" color="#ff1d5e" />
        </div>
        <div class="m-auto" v-if="value.photo.welcome !== ''">
          <img class="bg-white img-fluid rounded-circle mx-auto my-auto" width="100" :src="value.photo.welcome" :data-source="value.photo.welcome" alt="" />
        </div>
      </div>

  <v-card
        :style="{ background: value?.pallete?.headColor, color: value?.pallete?.textColor }"
        light
        flat
        class="overflow-y-auto rounded-lg view-wrapper px-0 hide-scrollbar" 
        height="70vh"
        max-height="660"

      >
        <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="value?.visitName || 'کارت ویزیت'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="value?.identifier || ''"
          :profile-avatar="value?.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>

      <drag-list v-model="computedOrders">
          <template v-slot:default="{ item }">
            
            <div :key="item.name || item" class="drag-item-wrapper flex-grow-1 overflow-hidden" style="max-width: calc(100% - 32px);">

      <template v-if="item === 'profile'">
          <profile-photos :value="value.photo" :size="'60px'" class="mt-8"></profile-photos>
       </template>
      <template v-if="item === 'organizationInfo'">
        <div class="mx-auto text-center mb-0 pt-3 pb-0">
          <p :class="value && value.photo && value.photo.profile ? 'font-weight-bold text-center' : 'font-weight-bold text-center pr-6'">
            {{ value.organizationName }}
          </p>
          <p class="pr-6 text-center">{{ value.subtitle }}</p>
        </div>
        </template>
        <template v-if="item === 'headerImage'">

        <header-image
          :style="{ background: value.pallete?.bodyColor, color: value.pallete?.textColor }"
          :is-img="true"
          class="mt-0 pt-0 mx-auto"
          v-model="value.banner"
        />
        </template>
    <div class="text-center my-4" v-if="item === 'memories'">
      <h3 class="font-weight-bold" :style="{ color: value?.pallete?.textColor }">
        <v-icon large color="error">mdi-calendar-heart</v-icon>
        تاریخ‌های ماندگار
      </h3>
    </div>

  <div v-if="item === 'memories'" :style="{ borderRadius: 3, background: value.pallete?.bodyColor, color: value.pallete?.textColor }"
 class="custom-timeline w-100 py-4" :class="value?.memories?.some(m => m.icon) ? 'has-icons' : 'no-icons'">
    <div class="timeline-line" :style="{ background: value?.pallete?.textColor || 'white' }"></div>
        
  <div
    v-for="(memory, index) in value.memories"
    :key="'mem-'+index"
    class="d-flex align-center position-relative z-1 w-100"
    :class="index !== value.memories.length - 1 ? 'mb-10' : ''"
  >
    <template v-if="value?.memories?.some(m => m.icon)">
      <div class="icon-container">
        <v-icon v-if="memory.icon" size="48" :style="{ color: value?.pallete?.textColor }">
          {{ memory.icon }}
        </v-icon>
      </div>

      <!-- ۲. قلب -->
      <div class="timeline-node">
         <v-icon size="20" color="#E3242B">mdi-heart</v-icon>
      </div>

      <!-- ۳. عنوان و تاریخ در سمت چپ -->
      <div class="flex-grow-1 text-right mr-4">
        <div class="font-weight-bold text-subtitle-1 mb-2" :style="{ color: value?.pallete?.textColor }">
          {{ memory.title }}
        </div>
        <div class="text-caption font-weight-medium" :style="{ color: value?.pallete?.textColor, opacity: 0.7 }">
          <span dir="ltr">{{ memory.date }}</span>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="half-width text-left pl-3" :style="{ color: value?.pallete?.textColor, opacity: 0.7 }">
        <span dir="ltr" class="text-caption font-weight-medium">{{ memory.date }}</span>
      </div>

      <div class="timeline-node mx-1">
         <v-icon size="20" color="#F8F0F1">mdi-heart</v-icon>
      </div>

      <div class="half-width text-right pr-3 font-weight-bold text-subtitle-1" :style="{ color: value?.pallete?.textColor }">
        {{ memory.title }}
      </div>
    </template>
  </div>
</div>
        
              <!-- گالری تصاویر -->
              <template v-if="item === 'gallery'">
                <component
                  :is="value?.PicSelector?.slider ? 'gallery-slider' : 'b-gallery-view'"
                  :new-position="true"
                  :style="{ background: value?.pallete?.bodyColor, color: value?.pallete?.textColor }"
                  class="pt-5"
                  v-model="value.gallery"
                  :title="value.PicSelector?.title"
                  :description="value.PicSelector?.description"
                  :is-img="true"
                  :is-grid="value?.PicSelector?.grid"
                  :orientation ="value?.PicSelector?.orientation"
                />
              </template>

              <!-- گالری ویدیو -->
              <template v-if="item === 'video_gallery'">
                <div v-if="value?.VideoGallery?.secondPosition">
                  <template v-for="(v, i) in value.video_gallery">
                    <video-card-view
                      v-if="v?.images?.length > 0"
                      :key="'vid-'+i"
                      :description="value.VideoGallery"
                      :style="{ background: value?.pallete?.bodyColor, color: value?.pallete?.textColor }"
                      :data="v"
                    />
                  </template>
                </div>
                <b-gallery-view
                  v-if="!value?.VideoGallery?.slider && !value.VideoGallery?.secondPosition"
                  :style="{ background: value?.pallete?.bodyColor, color: value?.pallete?.textColor }"
                  :is-img="false"
                  :title="value.VideoGallery.title"
                  :is-grid="false"
                  :description="value.VideoGallery.description"
                  v-model="value.video_gallery"
                  :orientation ="value?.PicSelector?.orientation"

                />
              </template>

              <!-- گالری صوت -->
              <template v-if="item === 'audiosGallery' && value?.audiosGallery?.audios?.length > 0">
                <voice-card-view
                  :style="{ background: value?.pallete?.bodyColor, color: value?.pallete?.textColor }"
                  :data="value?.audiosGallery?.audios"
                  :type="value?.audiosGallery?.audioType"
                />
              </template>

              <template v-if="item === 'website' && value.website">
                <v-card-text
                  v-if="!isGiftRoute"
                  class="font-size-h5 d-flex mt-0 pt-3 flex-column"
                  :style="{ color: value.pallete.textColor }"
                >
                  <a
                    :href="fixLink(value.website)"
                    target="_blank"
                    rel="noopener noreferrer"
                    :style="{ color: value.pallete.textColor }"
                  >
                    <v-icon class="ml-auto" :color="value.pallete.textColor">
                      mdi-web
                    </v-icon>
                    {{ value.website }}
                  </a>
                </v-card-text>

                <v-card-text
                  v-if="isGiftRoute"
                  class="font-size-h5 d-flex mt-0 pt-3 flex-column"
                  :style="{ color: value.pallete.textColor }"
                >
                  <div :style="{ color: value.pallete.textColor }">
                    <v-icon class="ml-auto" :color="value.pallete.textColor">
                      mdi-heart
                    </v-icon>
                    {{ value.website }}
                  </div>
                </v-card-text>
              </template>

              <template v-if="item === 'aboutUs' && value.aboutUs">
                <v-card-text
                  class="font-size-h5 d-flex mt-0 pt-3 flex-column about-us-wrapper"
                >
                  <p
                    dir="auto"
                    class="about-us-text"
                    :style="{ color: value.pallete.textColor }"
                  >
                    {{ value.aboutUs }}
                  </p>
                </v-card-text>
              </template>


              <!-- اطلاعات تماس -->
              <template v-if="item === 'showInfo'">
                <show-info
                  class="mt-0"
                  v-model="value"
                  @intersecting="showFloatBtn = !$event"
                />
              </template>

            </div>

          </template>
        </drag-list>

      </v-card>
    </component>
  </mock-up-main>
</template>

<script>
import { Bus } from "../../../../../main"; 
import HeaderImage from "@/view/pages/otherQrTypes/giftGallery/components/headerImage";
import ShowInfo from "@/view/pages/otherQrTypes/giftGallery/components/showInfo";
import BGalleryView from "@/view/pages/businessPage/components/view/bGalleryView";
import GallerySlider from "@/view/pages/businessPage/components/view/gallerySlider";
import {
  VFadeTransition,
  VScaleTransition,
  VSlideXTransition,
  VSlideYTransition,
} from "vuetify/lib/components";
import MockUpMain from "../../../businessPage/components/mockUp";
import ProfilePhotos from "../../../../components/repeatitive/profilePhotos";
import VideoCardView from "@/view/pages/otherQrTypes/videoGallery/components/videoCardView";
import voiceCardView from "../../../Voice/components/voiceCardView.vue";
import DragList from "@/view/pages/qrland/dragList.vue"; 
import UniversalQrModal from "../../../../components/UniversalQrModal.vue";

const GIFT_ROUTES = [
  "qr.gift",
  "qr.name.editgift",
  "qr.name.id.editgift",
    "modelsList.memories.edit",
  "qr.create.memories"

];

export default {
  name: "galleryMobile",
  components: {
    ProfilePhotos,
    MockUpMain,
    GallerySlider,
    BGalleryView,
    ShowInfo,
    HeaderImage,
    VideoCardView,
    voiceCardView,
    DragList,
    UniversalQrModal
  },
  props: {
    value: { type: Object, default: () => ({}) },
    qrSvgDataUrl: {
      type: String,
      default: "",
    },

  },
  data() {
    return {
      showQrDialog: false,
      showWelcome: false,
      showFloatBtn: false,
      components: {
        scale: VScaleTransition,
        slideX: VSlideXTransition,
        slideY: VSlideYTransition,
        fade: VFadeTransition,
      },
    };
  },
    computed: {
          primaryActionColor() {
      return this.value?.pallete?.bodyColor || "#1976D2";
    },
       computedOrders: {
      get() {
        return this.orders && this.orders.length > 0 
          ? this.orders 
          : (this.value.orders || []);
      },
      set(newValue) {
        this.$emit("update:orders", newValue);
        
        let updatedValue = { ...this.value, orders: newValue };
        this.$emit("input", updatedValue);
      }
    },
    isGiftRoute() {
      return GIFT_ROUTES.includes(this.$route.name);
    }
  },
    methods: {
    fixLink(link) {
      if (!link) return "";
      return /^https?:\/\//i.test(link) ? link : `https://${link}`;
    },
  },
  mounted() {
    Bus.$on("showMe", (value) => {
      if (this.value && this.value?.photo && this.value?.photo?.hasWelcome) {
        this.showWelcome = true;
        setTimeout(() => {
          this.showWelcome = false;
        }, 3000);
      }
    });
  }
};
</script>
<style scoped>
.hide-scrollbar {
  -ms-overflow-style: none; 
  scrollbar-width: none;  
}
.hide-scrollbar::-webkit-scrollbar {
  display: none; 
}
.about-us-wrapper {
  padding-inline: 24px;
}

.about-us-text {
  width: 100%;
  margin: 0;
  white-space: pre-line;
  unicode-bidi: plaintext;
  text-align: start;
  line-height: 1.2;
  overflow-wrap: break-word;
  word-break: normal;
  text-align: justify;
}

.custom-timeline {
  position: relative;
  padding-right: 4px;
}
.timeline-line {
  position: absolute;
  top: 25px; 
  bottom: 25px; 
  right: 100px; 
  width: 1.5px;
  opacity: 0.3;
  z-index: 0;
}
.timeline-line {
  position: absolute;
  top: 30px; 
  bottom: 40px; 
  right: 28px; /* این عدد را به شدت کاهش دادیم */
  width: 1.5px;
  background-color: white; /* یا هر رنگی که برای خط در نظر دارید */
  opacity: 0.3;
  z-index: 0;
}
.timeline-node {
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  flex-shrink: 0;
  background: transparent;
}
.z-1 {
  z-index: 1;
}
.timeline-line {
  position: absolute;
  width: 1.5px;
  opacity: 0.3;
  z-index: 0;
  transition: all 0.3s ease;
}

.custom-timeline.has-icons .timeline-line {
  top: 25px; 
  bottom: 23px; 
  right: 100px; 
}

.custom-timeline.no-icons .timeline-line {
  top: 25px; 
  bottom: 23px; 
  right: 14px; 
}
.icon-container {
  width: 86px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.timeline-node {
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  flex-shrink: 0;
  background: transparent;
}

.timeline-line {
  position: absolute;
  width: 1.5px;
  opacity: 0.3;
  z-index: 0;
  transition: all 0.3s ease;
}

.custom-timeline.has-icons .timeline-line {
  top: 25px; 
  bottom: 23px; 
  right: 100px; 
}

.custom-timeline.no-icons .timeline-line {
  top: 25px; 
  bottom: 23px; 
  right: 14px; 
}
.timeline-line {
  position: absolute;
  width: 1.5px;
  opacity: 0.3;
  z-index: 0;
  transition: all 0.3s ease;
  top: 25px; 
  bottom: 23px; 
}

.custom-timeline.has-icons .timeline-line {
  right: 100px; 
}

.custom-timeline.no-icons .timeline-line {
  right: 50%;
  transform: translateX(50%);
}

.half-width {
  flex: 1;
  width: 50%;
}
.qr-floating-btn {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}

</style>
